/*
 * @Author: zjg
 * @Date: 2020-04-14 15:14:33
 * @LastEditTime: 2020-04-29 17:43:57
 * @Deccription: 当前预览文件的全局状态
 */
import TYPES from '../types'

export const filedataSate = {
  curFileInfo: {},
}
export const filedataMutations = {
  [TYPES.GET_CUR_FILE_INFO](state, data) {
    state.curFileInfo = data
  },
}
